import { Button } from "@fanduel/og-fe-library";
import Link from "next/link";
import Image from "@/components/Image";
import { NEWS_CTA_CLICKED } from "@/constants/amplitude";
import { Sport } from "@/graphql/gql/graphql";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import styles from "./featuredSportHeader.module.scss";

type LeagueSectionHeaderProps = {
  sportName: Sport["name"];
  sportSlug: Sport["slug"];
  sportLogo?: Sport["logo"];
  title?: string;
};

const FeaturedSportHeader = ({
  sportName,
  sportSlug,
  sportLogo,
  title,
}: LeagueSectionHeaderProps) => {
  const buttonText = `View all ${sportName} news`;

  const { logAmplitudeEvent } = useAmplitude();

  const handleClick = () => {
    logAmplitudeEvent(NEWS_CTA_CLICKED, {
      "Link Text": buttonText,
      "Link URL": `/${sportSlug}`,
      Module: "news",
    });
  };

  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>
        {sportLogo?.url && (
          <Image
            style={{
              display: "inline",
              height: "30px",
              marginRight: ".5rem",
              width: "auto",
            }}
            width={30}
            height={30}
            alt={sportName}
            src={sportLogo?.url}
          />
        )}
        {title ?? sportName}
      </h3>
      <Link href={`/${sportSlug}`} className={styles.link}>
        <Button
          ariaLabelText={buttonText}
          buttonText={buttonText}
          buttonStyle="Naked"
          rightIconName="arrows.right"
          iconColor="colorBaseBlueDarken2"
          className={styles.button}
          onClick={handleClick}
        />
      </Link>
    </div>
  );
};

export default FeaturedSportHeader;
